/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCreateManualAlertCommand,
    InternalApiCreateManualAlertCommandFromJSON,
    InternalApiCreateManualAlertCommandToJSON,
    InternalApiManualAlert,
    InternalApiManualAlertFromJSON,
    InternalApiManualAlertToJSON,
} from '../models';

export interface CreateManualAlertRequest {
    internalApiCreateManualAlertCommand: InternalApiCreateManualAlertCommand;
}

export interface GetManualAlertRequest {
    id: number;
}

export interface GetManualAlertsRequest {
    personId?: string;
    transactionId?: string;
    page?: number;
    size?: number;
    sort?: string;
}

export interface UpdateManualAlertRequest {
    id: number;
    internalApiCreateManualAlertCommand: InternalApiCreateManualAlertCommand;
}

/**
 * 
 */
export class ManualAlertInternalApi extends runtime.BaseAPI {

    /**
     * Create manual alert
     */
    async createManualAlertRaw(requestParameters: CreateManualAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiManualAlert>> {
        if (requestParameters.internalApiCreateManualAlertCommand === null || requestParameters.internalApiCreateManualAlertCommand === undefined) {
            throw new runtime.RequiredError('internalApiCreateManualAlertCommand','Required parameter requestParameters.internalApiCreateManualAlertCommand was null or undefined when calling createManualAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/manual-alerts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateManualAlertCommandToJSON(requestParameters.internalApiCreateManualAlertCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiManualAlertFromJSON(jsonValue));
    }

    /**
     * Create manual alert
     */
    async createManualAlert(requestParameters: CreateManualAlertRequest, initOverrides?: RequestInit): Promise<InternalApiManualAlert> {
        const response = await this.createManualAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get manual alert by ID
     */
    async getManualAlertRaw(requestParameters: GetManualAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiManualAlert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getManualAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/manual-alerts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiManualAlertFromJSON(jsonValue));
    }

    /**
     * Get manual alert by ID
     */
    async getManualAlert(requestParameters: GetManualAlertRequest, initOverrides?: RequestInit): Promise<InternalApiManualAlert> {
        const response = await this.getManualAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get manual alerts
     */
    async getManualAlertsRaw(requestParameters: GetManualAlertsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiManualAlert>>> {
        const queryParameters: any = {};

        if (requestParameters.personId !== undefined) {
            queryParameters['personId'] = requestParameters.personId;
        }

        if (requestParameters.transactionId !== undefined) {
            queryParameters['transactionId'] = requestParameters.transactionId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/manual-alerts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiManualAlertFromJSON));
    }

    /**
     * Get manual alerts
     */
    async getManualAlerts(requestParameters: GetManualAlertsRequest = {}, initOverrides?: RequestInit): Promise<Array<InternalApiManualAlert>> {
        const response = await this.getManualAlertsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update manual alert
     */
    async updateManualAlertRaw(requestParameters: UpdateManualAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiManualAlert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateManualAlert.');
        }

        if (requestParameters.internalApiCreateManualAlertCommand === null || requestParameters.internalApiCreateManualAlertCommand === undefined) {
            throw new runtime.RequiredError('internalApiCreateManualAlertCommand','Required parameter requestParameters.internalApiCreateManualAlertCommand was null or undefined when calling updateManualAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/manual-alerts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateManualAlertCommandToJSON(requestParameters.internalApiCreateManualAlertCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiManualAlertFromJSON(jsonValue));
    }

    /**
     * Update manual alert
     */
    async updateManualAlert(requestParameters: UpdateManualAlertRequest, initOverrides?: RequestInit): Promise<InternalApiManualAlert> {
        const response = await this.updateManualAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
